import ChangeTypeForm from "./ChangeTypeForm.component.jsx";

export default ChangeTypeForm;